import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=989dc5cc&scoped=true&"
import script from "./page6.vue?vue&type=script&lang=js&"
export * from "./page6.vue?vue&type=script&lang=js&"
import style0 from "./page6.vue?vue&type=style&index=0&lang=less&"
import style1 from "./page6.vue?vue&type=style&index=1&id=989dc5cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989dc5cc",
  null
  
)

export default component.exports